import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const SingleText = ({ blok }) => (
  <div className="singletext-wrap" {...storyblokEditable(blok)}>
    <p className="singletext-text">{blok.text}</p>
  </div>
);

export default SingleText;